import React, { useContext, type HTMLAttributes } from 'react'

import { PageClose } from '../../saas/components/Page/Close'
import { DrawersContext } from './DrawersProvider'

export function Close(props: HTMLAttributes<HTMLButtonElement>) {
  const { closeDrawer } = useContext(DrawersContext)

  return <PageClose onClick={() => closeDrawer()} {...props} />
}

Close.displayName = 'PageClose'
